/**
 * Appends the editable "Loved by" line into the Judge.me preview badge
 * so it reads as one string with the review count, for example
 * "54 reviews · Loved by thousands of Australian homes".
 *
 * The phrase stays in the theme editor text block. Judge.me is an app
 * embed and may render the badge after this script runs, and it may
 * replace the badge markup later, so this keeps watching and re-applies.
 */
(function () {
  const BLOCK_SELECTOR = '[class*="__pdp_loved_by"]';
  const SUFFIX_CLASS = 'pdp-loved-by-suffix';
  const watching = new WeakSet();

  function phraseFrom(block) {
    return (block.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function apply(block) {
    const phrase = phraseFrom(block);
    const row = block.closest('.group-block');
    if (!row) return;

    const badgeText = row.querySelector('.jdgm-prev-badge__text');
    const suffix = badgeText ? badgeText.querySelector(':scope > .' + SUFFIX_CLASS) : null;

    if (!badgeText || !phrase) {
      if (suffix) suffix.remove();
      block.classList.remove('pdp-loved-by--merged');
      return;
    }

    const next = ' \u00b7 ' + phrase;
    let node = suffix;

    if (!node) {
      node = document.createElement('span');
      node.className = SUFFIX_CLASS;
      badgeText.appendChild(node);
    }

    if (node.textContent !== next) node.textContent = next;
    block.classList.add('pdp-loved-by--merged');
  }

  function sync(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BLOCK_SELECTOR).forEach(apply);
  }

  function watch(root) {
    if (!root || watching.has(root)) {
      sync(root);
      return;
    }

    watching.add(root);

    let frame = 0;
    const observer = new MutationObserver(function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        sync(root);
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    sync(root);
  }

  function start() {
    document.querySelectorAll('.product-information').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target;
    if (!target || !target.querySelectorAll) {
      start();
      return;
    }

    if (target.classList.contains('product-information')) {
      watch(target);
      return;
    }

    target.querySelectorAll('.product-information').forEach(watch);
  });
})();
